import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ContentService, SeoService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { Subject } from 'rxjs';

@Component({
  selector: 'lcp-collection-default',
  templateUrl: './collection-default.component.html',
  styleUrls: ['./collection-default.component.scss']
})
export class CollectionDefaultComponent implements OnInit, OnDestroy {
  // jobListing: TypeJobListingFields | null = null;
  route$: any
  filter$: any
  // filterLookup: any
  project: any
  projectFeaturedMedia: any[]
  projectTags: any[]

  fields: any

  destroy$: Subject<boolean> = new Subject<boolean>();
  slug: string
  
  constructor(
    public contentService: ContentService,
    public lcpHelper: LcpHelper, 
    public route: ActivatedRoute,
    private seoService: SeoService
  ) { }

  ngOnInit(): void {
    this.slug = 'service--' + this.route.snapshot.params['slug']
    this.routeStream()
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  routeStream() {
    return this.route.paramMap
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (params: ParamMap) => {
      this.slug = 'collection--' + params.get('slug')
      this.getPage()
    }})
  }

  getPage(){
    this.contentService.getPage({ 'fields.slug': this.slug })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (content) => {
        if (!content || !content.items[0]) {
          this.seoService.update({ title: 'collection not found', noindex: true })
          return console.log('ERR: !content', content)
        }
        // console.log('CHECK content', content)
        this.fields = content.items[0].fields
        // console.log('fields', this.fields)
        this.seoService.setStructuredData([
          SeoService.breadcrumbs([['collections', '/collections'], [this.fields['title'], '/' + this.slug.replace('collection--', 'collections/')]]),
        ])
        this.seoService.update({
          title: `${this.fields['title']} | collections`,
          description: SeoService.text(this.fields['subheading'], `${this.fields['title']}: a collection of work by lowercase productions, a San Francisco visual design and communications agency.`),
          image: SeoService.image(this.fields['banner']),
        })
      }
    });
  }
  
}
